<template>
    <div class="LkStudents">
        <SideMenu :testStudent="true">
            <template v-slot:testStudent>
                <ul class="testStudent-menu mt-6">
                    <p>Ваши действия</p>
                    <li v-for="(item, index) in getRoute" :key="'F'+index" v-show="item.view">
                        <div class="icon">
                            <inline-svg v-if="item.success" :src="require(`@/assets/img/icons/SuccessStep.svg`)" />
                        </div>

                        <div class="text">
                            {{ item.name }}
                        </div>
                    </li>
                </ul>
            </template>
        </SideMenu>
        <MobileHeaderMenu :testStudent="true" :actions="getRoute">
            <template v-slot:testStudentMobile>
                <div v-show="!getShowContainers" class="time">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 32 32" fill="none">
                        <path d="M15.9998 30.3334C8.09317 30.3334 1.6665 23.9067 1.6665 16.0001C1.6665 8.09341 8.09317 1.66675 15.9998 1.66675C23.9065 1.66675 30.3332 8.09341 30.3332 16.0001C30.3332 23.9067 23.9065 30.3334 15.9998 30.3334ZM15.9998 3.66675C9.19984 3.66675 3.6665 9.20008 3.6665 16.0001C3.6665 22.8001 9.19984 28.3334 15.9998 28.3334C22.7998 28.3334 28.3332 22.8001 28.3332 16.0001C28.3332 9.20008 22.7998 3.66675 15.9998 3.66675Z" fill="#fff"/>
                        <path d="M20.9467 21.2401C20.7734 21.2401 20.6 21.2001 20.44 21.0934L16.3067 18.6268C15.28 18.0134 14.52 16.6668 14.52 15.4801V10.0134C14.52 9.46676 14.9734 9.01343 15.52 9.01343C16.0667 9.01343 16.52 9.46676 16.52 10.0134V15.4801C16.52 15.9601 16.92 16.6668 17.3334 16.9068L21.4667 19.3734C21.9467 19.6534 22.0934 20.2668 21.8134 20.7468C21.6134 21.0668 21.28 21.2401 20.9467 21.2401Z" fill="#fff"/>
                    </svg>
                    <TimerSetup :time="prettyTime" />
                </div>
            </template>
        </MobileHeaderMenu>
        <div class="testStudent testStudent-mobile">
            <div class="testStudent-conainer testStudent-conainer-mobile">
                <div v-show="!getShowContainers" class="testStudent-header testStudent-header-mobile">
                    <div class="header-time">
                        <h1>{{ getGeneral.info.title }}</h1>
                        <div class="time-container">
                            <div class="time">
                                <TimerSetup :time="prettyTime" />
                                <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                                    <path d="M15.9998 30.3334C8.09317 30.3334 1.6665 23.9067 1.6665 16.0001C1.6665 8.09341 8.09317 1.66675 15.9998 1.66675C23.9065 1.66675 30.3332 8.09341 30.3332 16.0001C30.3332 23.9067 23.9065 30.3334 15.9998 30.3334ZM15.9998 3.66675C9.19984 3.66675 3.6665 9.20008 3.6665 16.0001C3.6665 22.8001 9.19984 28.3334 15.9998 28.3334C22.7998 28.3334 28.3332 22.8001 28.3332 16.0001C28.3332 9.20008 22.7998 3.66675 15.9998 3.66675Z" fill="#4854FE"/>
                                    <path d="M20.9467 21.2401C20.7734 21.2401 20.6 21.2001 20.44 21.0934L16.3067 18.6268C15.28 18.0134 14.52 16.6668 14.52 15.4801V10.0134C14.52 9.46676 14.9734 9.01343 15.52 9.01343C16.0667 9.01343 16.52 9.46676 16.52 10.0134V15.4801C16.52 15.9601 16.92 16.6668 17.3334 16.9068L21.4667 19.3734C21.9467 19.6534 22.0934 20.2668 21.8134 20.7468C21.6134 21.0668 21.28 21.2401 20.9467 21.2401Z" fill="#4854FE"/>
                                </svg>
                            </div>
                            <v-btn class="btn-card-mobile intro-info" @click="getResultPatient" :loading="loadResultPatient" :disabled="disableBtn" :class="{'disableBtn': disableBtn}">Показатели пациента</v-btn>
                        </div>
                    </div>
                    <div class="header-card header-card-mobile ">
                        <div class="card-icon">
                            <img :src="require('@/assets/img/default-profile-image.png')" alt="icon">
                            <div class="card-name mt-3">
                                <div class="name">{{ getGeneral.info.patient && getGeneral.info.patient.fio }}</div>
                                <div class="gender">
                                    <p>Пол:</p>
                                    <div :class="{ 'male': getGeneral.info.patient && getGeneral.info.patient.gender === 0, 'female': getGeneral.info.patient && getGeneral.info.patient.gender == 1 }">
                                        {{ getGeneral.info.patient && getGeneral.info.patient.gender === 0 ? 'М' : 'Ж' }}
                                    </div>
                                    <span class="age">
                                        Возраст: <span class="num">
                                            {{
                                                getGeneral.info.patient
                                                && getGeneral.info.patient.episodes
                                                && getGeneral.info.patient.episodes[0]
                                                && getGeneral.info.patient.episodes[0].ageText
                                            }}
                                        </span>
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div class="card-description">
                            <p class="description-info">Краткое описание</p>
                            <div class="description-txt">
                                <p>{{ getGeneral.info.description }}</p>
                            </div>
                        </div>
                        <v-btn @click="getResultPatient" class="btn-card intro-info" :disabled="disableBtn" :class="{'disableBtn': disableBtn}">Показатели пациента</v-btn>
                    </div>
                </div>

                <router-view>
                    <template slot="btn">
                        <v-btn v-if="!checkingLastStep" :loading="loadNext" @click.prevent="next">Дальше</v-btn>
                        <v-btn v-if="checkingLastStep" :loading="loadingEndTest" class="btn ml-2" @click="endTest">Завершить</v-btn>
                    </template>
                </router-view>
            </div>
        </div>

        <v-dialog v-model="showResult" max-width="1276">
            <div class="media-container">
                <div class="containerShadowN">
                    <v-btn class="bodySystems-close" @click.prevent="showResult=false">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <path d="M6 5L18.7279 17.7279" stroke="#4854FE" stroke-width="2" stroke-linecap="round"/>
                            <path d="M6 18L18.7279 5.27208" stroke="#4854FE" stroke-width="2" stroke-linecap="round"/>
                        </svg>
                    </v-btn>
                    <div class="deletEl research-container">
                        <DiagnosticResults />
                    </div>
                </div>
            </div>
        </v-dialog>

        <v-dialog v-model="dialogTimer" max-width="500" persistent>
            <v-card>
                <v-card-title class="text-h5 grey lighten-2">Информация</v-card-title>

                <v-card-text>
                    {{ textInfo }}
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn :loading="loadingCheckInternet" color="primary" text @click="checkInternet">
                        Проверить соединение
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="getSprPhysResearch.dialogMedia" max-width="900" persistent>
            <v-card>
                <v-card-title class="text-h5 grey lighten-2">Медиафайлы</v-card-title>

                <v-row class="ma-4" no-gutters>
                    <v-col class="d-sm-none d-md-none d-lg-none" cols="12" md="12">
                        <v-select :items="itemsMedia" item-text="name" item-value="name" outlined v-model="mediaSelect" dense hide-details />
                    </v-col>

                    <v-col class="d-sm-none d-md-none d-lg-none" cols="12" v-if="mediaSelect == 'Аудиофайлы'" md="12">
                        <media-files
                            class="mt-4"
                            v-if="getSprPhysResearch.selectedCircle.files.length > 0"
                            :files="getSprPhysResearch.selectedCircle.files.filter((f) => f.fileType === 3)"
                            :flagDiag="true"
                            :flagButtonDel="true"
                            :flagNameAndBtn="false"
                        />
                    </v-col>
                    <v-col class="d-sm-none d-md-none d-lg-none" cols="12" v-if="mediaSelect == 'Видеофайлы'" md="12">
                        <media-files
                            class="mt-4"
                            v-if="getSprPhysResearch.selectedCircle.files.length > 0"
                            :files="getSprPhysResearch.selectedCircle.files.filter((f) => f.fileType === 4)"
                            :flagDiag="true"
                            :flagButtonDel = "true"
                            :flagNameAndBtn="false"
                        />
                    </v-col>
                    <v-col class="d-sm-none d-md-none d-lg-none" cols="12" v-if="mediaSelect == 'Изображение'" md="12">
                        <media-files
                            class="mt-4"
                            v-if="getSprPhysResearch.selectedCircle.files.length > 0"
                            :files="getSprPhysResearch.selectedCircle.files.filter((f) => f.fileType === 2)"
                            :flagDiag="true"
                            :flagButtonDel = "true"
                            :flagNameAndBtn="false"
                        />
                    </v-col>

                    <v-col class="d-none d-sm-block d-md-block d-lg-block" cols="12" md="12">
                        <div class="createTest-tabs">
                            <v-tabs v-model="tabMedia" align-with-title>
                                <v-tab v-for="(item, key) in itemsMedia" :key="key" >
                                    {{ item }}
                                    <span v-if="key === 0">({{ getSprPhysResearch.selectedCircle.files.filter((f) => f.fileType === 3).length }})</span>
                                    <span v-if="key === 1">({{ getSprPhysResearch.selectedCircle.files.filter((f) => f.fileType === 4).length }})</span>
                                    <span v-if="key === 2">({{ getSprPhysResearch.selectedCircle.files.filter((f) => f.fileType === 2).length }})</span>
                                </v-tab>
                            </v-tabs>
                            <v-tabs-items v-model="tabMedia">
                                <v-tab-item v-for="(item, key) in itemsMedia" :key="key">
                                    <div class="media-container mt-4" v-if="item == 'Аудиофайлы'">
                                        <media-files
                                            v-if="getSprPhysResearch.selectedCircle.files.length > 0"
                                            :files="getSprPhysResearch.selectedCircle.files.filter((f) => f.fileType === 3)"
                                            :flagDiag="true"
                                            :flagButtonDel="false"
                                        />
                                    </div>

                                    <div class="media-container mt-4" v-if="item == 'Видеофайлы'">
                                        <media-files
                                            v-if="getSprPhysResearch.selectedCircle.files.length > 0"
                                            :files="getSprPhysResearch.selectedCircle.files.filter((f) => f.fileType === 4)"
                                            :flagDiag="true"
                                            :flagButtonDel="false"
                                        />
                                    </div>

                                    <div class="media-container mt-4" v-if="item == 'Изображение'">
                                        <media-files
                                            v-if="getSprPhysResearch.selectedCircle.files.length > 0"
                                            :files="getSprPhysResearch.selectedCircle.files.filter((f) => f.fileType === 2)"
                                            :flagDiag="true"
                                            :flagButtonDel="false"
                                        />
                                    </div>
                                </v-tab-item>
                            </v-tabs-items>
                        </div>
                    </v-col>
                </v-row>

                <v-divider></v-divider>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" text @click="changeFlagMedia(false)">
                        Закрыть
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>


        <!-- <div class="containerShadow containerShadow-mobile" v-if="getSprPhysResearch.dialogMedia">
            <div class="containerEl containerEl-mobile">
                <button class="close" @click.prevent="changeFlagMedia(false)">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <path d="M6 5L18.7279 17.7279" stroke="#4854FE" stroke-width="2" stroke-linecap="round"/>
                        <path d="M6 18L18.7279 5.27208" stroke="#4854FE" stroke-width="2" stroke-linecap="round"/>
                    </svg>
                </button>
                <div class="addMedia addMedia-mobile">
                    <h2>Медиафайлы</h2>
                    <div class="createTest-tabs-mobile">
                        <v-select
                        :items="itemsMedia"
                        item-text="name"
                        item-value="name"
                        outlined
                        v-model="mediaSelect"
                        dense
                        hide-details
                        >
                        </v-select>
                        <div class="media-container" v-if="mediaSelect == 'Аудиофайлы'">
                                    <media-files
                                        v-if="getSprPhysResearch.selectedCircle.files.length > 0"
                                        :files="getSprPhysResearch.selectedCircle.files.filter((f) => f.fileType === 3)"
                                        :flagDiag="true"
                                        :flagButtonDel = "true"
                                    />
                                </div>

                                <div class="media-container" v-if="mediaSelect == 'Видеофайлы'">
                                    <media-files
                                        v-if="getSprPhysResearch.selectedCircle.files.length > 0"
                                        :files="getSprPhysResearch.selectedCircle.files.filter((f) => f.fileType === 4)"
                                        :flagDiag="true"
                                        :flagButtonDel = "true"
                                    />
                                </div>

                                <div class="media-container" v-if="mediaSelect == 'Изображение'">
                                    <media-files
                                        v-if="getSprPhysResearch.selectedCircle.files.length > 0"
                                        :files="getSprPhysResearch.selectedCircle.files.filter((f) => f.fileType === 2)"
                                        :flagDiag="true"
                                        :flagButtonDel = "true"
                                    />
                                </div>
                    </div>
                    <div class="createTest-tabs">
                        <v-tabs v-model="tabMedia" align-with-title>
                            <v-tab v-for="(item, key) in itemsMedia" :key="key" >
                                {{ item }}
                                <span v-if="key === 0">({{ getSprPhysResearch.selectedCircle.files.filter((f) => f.fileType === 3).length }})</span>
                                <span v-if="key === 1">({{ getSprPhysResearch.selectedCircle.files.filter((f) => f.fileType === 4).length }})</span>
                                <span v-if="key === 2">({{ getSprPhysResearch.selectedCircle.files.filter((f) => f.fileType === 2).length }})</span>
                            </v-tab>
                        </v-tabs>
                        <v-tabs-items v-model="tabMedia">
                            <v-tab-item v-for="(item, key) in itemsMedia" :key="key" >
                                <div class="media-container" v-if="item == 'Аудиофайлы'">
                                    <media-files
                                        v-if="getSprPhysResearch.selectedCircle.files.length > 0"
                                        :files="getSprPhysResearch.selectedCircle.files.filter((f) => f.fileType === 3)"
                                        :flagDiag="true"
                                        :flagButtonDel="false"
                                    />
                                </div>

                                <div class="media-container" v-if="item == 'Видеофайлы'">
                                    <media-files
                                        v-if="getSprPhysResearch.selectedCircle.files.length > 0"
                                        :files="getSprPhysResearch.selectedCircle.files.filter((f) => f.fileType === 4)"
                                        :flagDiag="true"
                                        :flagButtonDel="false"
                                    />
                                </div>

                                <div class="media-container" v-if="item == 'Изображение'">
                                    <media-files
                                        v-if="getSprPhysResearch.selectedCircle.files.length > 0"
                                        :files="getSprPhysResearch.selectedCircle.files.filter((f) => f.fileType === 2)"
                                        :flagDiag="true"
                                        :flagButtonDel="false"
                                    />
                                </div>
                            </v-tab-item>
                        </v-tabs-items>
                    </div>
                </div>
            </div>
        </div> -->

        <div class="containerShadow containerShadow-mobile" v-if="dialogResultPatient">
            <div class="containerEl containerEl-mobile">
                <button class="close" @click.prevent="dialogResultPatient = false">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <path d="M6 5L18.7279 17.7279" stroke="#4854FE" stroke-width="2" stroke-linecap="round"/>
                        <path d="M6 18L18.7279 5.27208" stroke="#4854FE" stroke-width="2" stroke-linecap="round"/>
                    </svg>
                </button>
                <div class="addMedia addMedia-mobile">
                    <h2>Показатели пациента</h2>
                    <div class="createTest-tabs">
                        <v-tabs v-model="tabMedia" align-with-title>
                            <v-tab v-for="(item, key) in itemsResultPatient" :key="'k'+key" >
                                {{ item.name }}
                                ({{ item.value.length }})
                            </v-tab>
                        </v-tabs>
                        <v-tabs-items class="custom-shadow" v-model="tabMedia">
                            <v-tab-item v-for="(item, key) in itemsResultPatient" :key="'u'+key" >
                                <div
                                    v-for="(it, ind) in item.value"
                                    :key="'f'+ind"
                                    class="result-patient"
                                    :class="{ 'choose': it.isPathology }"
                                    @click="sendPathology(item, it)"
                                >
                                    <span v-if="it.valueType === 1">
                                        {{ it.propertyName }}: {{ it.listValueName }}
                                    </span>
                                    <span v-if="it.valueType === 0">
                                        {{ it.propertyName }}: {{ it.avgValue }} {{ it.measurementName }}
                                    </span>
                                </div>
                            </v-tab-item>
                        </v-tabs-items>
                    </div>
                    <div class="createTest-tabs-mobile">
                        <v-select
                        :items="itemsResultPatient"
                        item-text="name"
                        item-value="id"
                        outlined
                        v-model="resultSelect"
                        return-object
                        dense
                        hide-details
                        />
                        <div
                        v-for="(it, ind) in resultSelect.value"
                        :key="'r'+ind"
                        class="result-patient"
                        :class="{ 'choose': it.isPathology }"
                        @click="sendPathology(resultSelect, it)"
                        >
                        <span v-if="it.valueType === 0">
                                {{ it.propertyName }}: {{ it.avgValue }} {{ it.measurementName }}
                         </span>
                         <span v-if="it.valueType === 1">
                                {{ it.propertyName }}: {{ it.listValueName }}
                         </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <v-dialog v-model="dialogResult" max-width="1200" persistent>
            <v-card>
                <v-container>
                    <resultComponent :data="resultObject" />
                </v-container>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import SideMenu from "@/components/SideMenu/SideMenu.vue"
import MobileHeaderMenu from "@/components/MobileHeaderMenu/index.vue"
import DiagnosticResults from "./DiagnosticResults/index.vue";
import TimerSetup from '@/components/Timer/index.vue'
import InlineSvg from 'vue-inline-svg';
import mediaFiles from '@/components/TaskMediaFiles.vue'
import resultComponent from './DiagnosticResults/index.vue'
import './index.scss'

export default {
    name: 'TestStudent',
    components: {
        SideMenu,
        DiagnosticResults,
        InlineSvg,
        mediaFiles,
        TimerSetup,
        MobileHeaderMenu,
        resultComponent
    },
    computed: {
        ...mapGetters({
            apiUrl: 'apiUrl',
            getGeneral: 'takeDiagnosticTest/getGeneral',
            getSprPhysResearch: 'takeDiagnosticTest/getSprPhysResearch',
            getRoute: 'takeDiagnosticTest/getRoute',
            getShowContainers: 'takeDiagnosticTest/getShowContainers',
            getIndexCurrentStep: 'takeDiagnosticTest/getIndexCurrentStep'
        }),
        prettyTime () {
            let hours = this.time / 3600  % 24,
                minutes = this.time / 60 % 60,
                seconds = this.time % 60;

            return `${Math.floor(hours)}:${Math.floor(minutes)}:${Math.floor(seconds)}`
		},
        sizeMobile(){
            switch (this.$vuetify.breakpoint.name) {
                case 'xs':
                    return true
                default:
                    return false
            }
        },
        checkingLastStep() {
            if(this.getRoute.length === 0) {
                return;
            }

            let currentStepIndex = null,
                lengthArray = this.getRoute.length - 1;

            for (let i = 0; i < this.getRoute.length; i++) {
                if(this.getRoute[i].view && !this.getRoute[i].success) {
                    currentStepIndex = i;
                    break;
                }
            }

            if(currentStepIndex < 0) {
                return;
            }

            // console.log('lengthArray === currentStepIndex', lengthArray, currentStepIndex);

            return lengthArray === currentStepIndex
        }
    },
    data: () => ({
        loadingGetResult: false,
        firstLvlOrder: null,
        currentStep: null,
        isStepSelected: false,
        resultObject: null,
        dialogResult: false,
        loadNext: false,
        loadingEndTest: false,
        listAntropometric: [],
        listVital: [],
        dialogResultPatient: false,
        loadTable: false,
        resultSelect: null,
        mediaSelect: 'Аудиофайлы',
        itemsMedia: [ 'Аудиофайлы', 'Видеофайлы', 'Изображение' ],
        itemsMediaMobile: [
            {
                name:'Аудиофайлы',
                id: 0
            },
            {
                name:'Видеофайлы',
                id: 1
            },
            {
                name:'Изображение',
                id: 2
            }
        ],
        itemsResultPatient: [
            { name: 'Витальные', id: 0, value: [] },
            { name: 'Антропометрические', id: 1, value: [] }
        ],
        tabMedia: 0,
        dialogTimer: false,
        textInfo: 'Соединение с интернетом прервано...',
        time: 0,
        timerSave: 0,
        isDisconect: false,
        loadingCheckInternet: false,
        showResult: false,
        disableBtn: false,
        loadResultPatient: false,
        correctlyAnswered: [
            'Это верный ответ!',
            'Правильно!',
            'Отлично! Продолжайте!',
            'Превосходно!',
            'Замечательно!',
            'Это фантастика! Великолепный результат!',
            'Искусственный интеллект аплодирует вам!',
            'Впечатляет!!!',
            'Отлично! Не все знают ответ на этот вопрос!',
            'Вы на пути к триумфу!'
        ],
        wrongAnswer: [
            'К сожалению, это неверно.',
            'Жаль! Вы были близки к правильному ответу.',
            'Неправильно. Придется повторить материал.',
            'А вы точно это учили?',
            'Соберитесь! Вы теряете баллы!',
            'Может, со следующим вопросом получится лучше?',
            'А вот и нет!',
            'Неверно! Надо бы повторить эту тему.',
            'Каждая ваша ошибка причиняет мне боль. Не делайте так!',
            'Ошибаться - это нормально, но впредь будьте внимательнее.'
        ]
    }),
    methods: {
        ...mapMutations({
            changeFlagMedia: 'takeDiagnosticTest/changeFlagMedia',
            resetTimer: 'takeDiagnosticTest/resetTimer',
            addTimer: 'takeDiagnosticTest/addTimer',
            stopTimer: 'takeDiagnosticTest/stopTimer',
            resetArrayRoute: 'takeDiagnosticTest/resetArrayRoute'
        }),
        ...mapActions({
            saveTime5s: 'takeDiagnosticTest/saveTime5s',
            getDiaTestProcessById: 'takeDiagnosticTest/getDiaTestProcessById',
            getSections: 'takeDiagnosticTest/getSections',
            diaTestGet: 'takeDiagnosticTest/diaTestGet',
            getVirtualInformation: 'takeDiagnosticTest/getVirtualInformation',
            getVitalPathologyAnswers: 'takeDiagnosticTest/getVitalPathologyAnswers',
            getAnthropometricPathologyAnswers: 'takeDiagnosticTest/getAnthropometricPathologyAnswers',
            sendVitalPathologyAnswer: 'takeDiagnosticTest/sendVitalPathologyAnswer',
            sendAnthropometricPathologyAnswer: 'takeDiagnosticTest/sendAnthropometricPathologyAnswer',
            addOrUpdateDiaTestProcessResult: 'takeDiagnosticTest/addOrUpdateDiaTestProcessResult',
            setNextStepForDiaTestProcess: 'takeDiagnosticTest/setNextStepForDiaTestProcess'
        }),
        changeResult(result) {
            this.resultSelect = result;
        },
        start() {
            if(!this.getGeneral.timer) {
                this.addTimer(setInterval( () => {
                    this.time++
                    this.timerSave++

                    if(this.timerSave === 5) {
                        this.saveTime5s(this.$route.params.id)
                            .then(() => {})
                            .catch((error) => {
                                if(error) {
                                    this.stopTimer();
                                    this.resetTimer();
                                    this.dialogTimer = true;
                                }
                            })
                        this.timerSave = 0;
                    }
                }, 1000 ))
            } else {
                clearInterval(this.getGeneral.timer);
            }
        },
        checkInternet() {
            this.loadingCheckInternet = true;

            this.saveTime5s(this.$route.params.id)
                .then((res) => {
                    if(res) {
                        this.textInfo = 'Cоединение с интернетом прервано...'
                        this.dialogTimer = false;
                        this.loadingCheckInternet = false;
                        this.start();
                    }
                })
                .catch((error) => {
                    if(error) {
                        this.textInfo = 'Проблема не решилась, соединение с интернетом прервано...'
                        this.loadingCheckInternet = false;
                    }
                })
        },
        getResultPatient() {
            this.loadResultPatient = true;
            this.getVitalPathologyAnswers(this.$route.params.id)
                .then((resVital) => {
                    this.itemsResultPatient[0].value = resVital;
                    this.resultSelect = this.itemsResultPatient[0]
                    this.getAnthropometricPathologyAnswers(this.$route.params.id)
                        .then((resAntropometric) => {
                            this.itemsResultPatient[1].value = resAntropometric;
                            this.loadResultPatient = false;
                            this.dialogResultPatient = true;
                        })
                })
        },
        sendPathology(item, it) {
            let nameActions = item.name === 'Витальные' ? 'sendVitalPathologyAnswer' : 'sendAnthropometricPathologyAnswer';
            it.isPathology = !it.isPathology;

            this[nameActions]({ processId: this.$route.params.id, answerPropertyId: it.id, isPathology: it.isPathology });
        },
        next() {
            console.log(this.lk);
            this.loadNext = true;
            this.setNextStepForDiaTestProcess(this.$route.params.id)
                .then(() => {
                    this.loadNext = false;
                    this.$router.replace(`/${this.lk}/dia-test/${this.$route.params.id}?diaTestId=${this.$route.query.diaTestId}&gender=${this.$route.query.gender}&age=${this.$route.query.age}`);
                })
        },
        nextToMobile() {
            this.$router.replace(`/lkstudents/dia-test/${this.$route.params.id}/diagnosis-result?diaTestId=${this.$route.query.diaTestId}`);
        },
        endTest() {
            this.stopTimer();
            this.resetTimer();
            this.loadingEndTest = true;

            // Если это моб версия, переходим на стр
            if(this.sizeMobile) {
                this.addOrUpdateDiaTestProcessResult(this.$route.params.id);
                this.nextToMobile()

                return;
            }

            this.addOrUpdateDiaTestProcessResult(this.$route.params.id)
                .then((res) => {
                    for (let i = 0; i < res.criteries.length; i++) {
                        this.$set(res.criteries[i], 'isOpen', false);
                        res.criteries[i].scoreText = this.getTextByResult(res.criteries[i].score);

                        if(res.criteries[i].title === 'Время диагностики'){
                            res.criteries[i].result = res.timer
                        }
                    }
                    this.resultObject = res;
                    this.dialogResult = true;
                    this.loadingEndTest = false;

                })
        },
        getTextByResult(score) {
            let name = '', index = 0;

            if(score <= 0) name = 'wrongAnswer'
            if(score >= 1) name = 'correctlyAnswered'

            index = Math.floor(Math.random() * this[name].length);

            return this[name][index]
        }
    },
    mounted() {
        if(this.$route.path.indexOf('diagnosis-result') > -1) return;

        this.start();
    },
    beforeDestroy() {
        this.stopTimer();
        this.resetTimer();
        this.resetArrayRoute();
    },
    created() {
        this.lk = this.$route.query.login === 'Metodist' ? 'lk' : this.$route.query.login === 'teacher' ? 'teacher' : 'lkstudents'
        // console.log(this.$route.query.login);
        this.getDiaTestProcessById(this.$route.params.id)
            .then((res) => {
                let s = res.data.timer.split('T')[1],
                    hour = +s.split(':')[0],
                    min = +s.split(':')[1],
                    sec = +s.split(':')[2];

                if(hour > 0 || min > 0 || sec > 0) this.time = ((hour * 60) * 60 ) + (min * 60) + sec;
            })

        this.diaTestGet(this.$route.query.diaTestId);
        this.getVirtualInformation(this.$route.query.diaTestId);
    }
}
</script>

<style lang="scss">
    .introjs-tooltipReferenceLayer {
        .introjs-tooltip {
            &-header {
                .introjs-skipbutton {
                    display: none;
                }
            }
            &buttons {
                a {
                    background: #4854FE !important;
                    color: #FFF  !important;
                    text-shadow: none !important;
                }
            }
        }
    }
</style>

<style lang="scss" scoped>
    .time {
        display: flex;
        height: 50px;
        padding: 12px 0px;
        justify-content: center;
        align-items: center;
        gap: 12px;
        span {
            color: #ffffff;
            font-family: Roboto;
            font-size: 15px;
            font-style: normal;
            font-weight: 800;
            line-height: 14px;
            letter-spacing: 0.12px;
        }
    }
</style>
